import React from 'react';
import { Instagram, Facebook, Twitter, Mail, Phone } from 'lucide-react';
import styles from './Footer.module.css';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Logo and Tagline Section */}
        <div className={styles.logoSection}>
          <div className={styles.logoWrapper}>
            {/* Replace with your actual logo */}
            <img src={logo} alt="Vibe Musicals Logo" className={styles.logo} />
          </div>
          <h2 className={styles.brandName}>VIBE MUSICALS</h2>
          <p className={styles.tagline}>One Stop for All Music Needs</p>
          
          <div className={styles.socialIcons}>
            <a href="https://www.instagram.com/vibemusicals/" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <Instagram size={24} />
            </a>
            <a href="https://www.facebook.com/p/Vibe-Musicals-61576914060894/" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <Facebook size={24} />
            </a>
           
          </div>
        </div>

        {/* Contact Us Section */}
        <div className={styles.contactSection}>
          <h3 className={styles.sectionTitle}>Contact Us</h3>
          
          <address className={styles.address}>
            13/6,2nd floor, MIG 13,Sholinganallur,<br />
            Chennai, Tamil Nadu 600119
          </address>
          
          <a href="mailto:thevibemusicals@gmail.com" className={styles.contactItem}>
            <Mail size={20} className={styles.contactIcon} />
            <span>thevibemusicals@gmail.com</span>
          </a>
          
          <a href="tel:9080465878" className={styles.contactItem}>
            <Phone size={20} className={styles.contactIcon} />
            <span>9080465878</span>
          </a>
        </div>

        {/* Quick Links Section */}
        <div className={styles.linksSection}>
          <h3 className={styles.sectionTitle}>Quick Links</h3>
          
          <nav className={styles.linksList}>
            <a href="#about" className={styles.link}>About Us</a>
            <a href="#achievements" className={styles.link}>Achievements</a>
            <a href="#courses" className={styles.link}>Courses</a>
            <a href="#contact" className={styles.link}>Contact</a>
          </nav>
        </div>
      </div>

      {/* Copyright */}
      <div className={styles.copyright}>
        © 2026 Vibe Musicals.All rights reserved
      </div>
    </footer>
  );
};

export default Footer;
